import { ExecutionPlanService } from '../services/execution-plan/execution-plan.service';

export class CronValidationUtils {
  static validateCustomCron(crontab: string, executionPlanService: ExecutionPlanService): boolean {
    if (!crontab || !crontab.trim()) return true; // Empty is valid (manual only)

    const validation = executionPlanService.validateCronExpression(crontab.trim());
    return validation.isValid;
  }

  static getCronValidationError(crontab: string, executionPlanService: ExecutionPlanService): string | null {
    if (!crontab || !crontab.trim()) return null;

    const validation = executionPlanService.validateCronExpression(crontab.trim());
    return validation.isValid ? null : validation.error || 'Invalid cron expression';
  }

  static getCronFormatExamples(): { label: string; example: string; description: string }[] {
    return [
      { label: 'Daily at 2 AM', example: '0 2 * * *', description: 'Run every day at 2:00 AM' },
      { label: 'Every hour', example: '0 * * * *', description: 'Run at the start of every hour' },
      { label: 'Every 15 minutes', example: '*/15 * * * *', description: 'Run every 15 minutes' },
      { label: 'Weekdays at 9 AM', example: '0 9 * * 1-5', description: 'Run Monday through Friday at 9:00 AM' },
      { label: 'Monthly on 1st', example: '0 0 1 * *', description: 'Run on the 1st of every month at midnight' },
      { label: 'Twice daily', example: '0 9,17 * * *', description: 'Run at 9:00 AM and 5:00 PM daily' }
    ];
  }
}

